export default __webpack_public_path__ + "static/media/file-group.ef3a3bba.svg";